var swiper = new Swiper(".reels-slider", {
   slidesPerView: "auto",
    spaceBetween: 0,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

});


$('.reels-video').parent().click(function () {

  // 👉 Pause all other videos
  $('.reels-video').not($(this).children(".reels-video")).each(function () {
    this.pause();
    $(this).siblings(".playpause").fadeIn();
  });

  if($(this).children(".reels-video").get(0).paused){        
    $(this).children(".reels-video").get(0).play();   
    $(this).children(".playpause").fadeOut();
  } else {       
    $(this).children(".reels-video").get(0).pause();
    $(this).children(".playpause").fadeIn();
  }
});